import { useState, useEffect, useRef } from "react"

const useCountdownThrottled = (initialSeconds = 60) => {
  const [seconds, setSeconds] = useState(initialSeconds)
  const [isCounting, setIsCounting] = useState(false) // 新增状态用来表示是否正在倒计时
  const intervalRef = useRef(null)

  useEffect(() => {
    const clearTimer = () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current)
        intervalRef.current = null
      }
    }

    if (isCounting) {
      intervalRef.current = setInterval(() => {
        setSeconds((prevSeconds) => {
          if (prevSeconds === 1) {
            setSeconds(initialSeconds) // 倒计时结束时重置为初始值
            setIsCounting(false) // 倒计时结束时停止计时
            clearTimer() // 清除定时器
          }
          return prevSeconds - 1
        })
      }, 1000)
    }

    return () => {
      clearTimer()
    }
  }, [isCounting]) // 当isCounting状态改变时重新运行效果

  const startCountdown = () => {
    setIsCounting(true)
  }

  const reset = () => {
    setSeconds(initialSeconds)
    setIsCounting(false) // 重置时停止倒计时
    clearInterval(intervalRef.current)
  }

  return { seconds, isCounting, startCountdown, reset }
}

export default useCountdownThrottled
